/**
 * Check setup (Rust `run_doctor/`): the read-only preflight, the repo file
 * editor's read/write (launch.json, .env) and "Create .env from example".
 * `@tauri-apps/api/core` is imported lazily (tests/tauriImportsAreLazy).
 */
async function invoke(cmd, args) {
  const core = await import('@tauri-apps/api/core');
  return core.invoke(cmd, args);
}

/** → { items, cached } (see run_doctor/mod.rs `Item`). Cached per repo + configurations unless `force`. */
export const checkSetup = (dir, configurations, force = false) => invoke('run_doctor_check', { dir, configurations, force });

/** → { content, mtime } for `.apiboo/launch.json` or an env file inside the repo. */
export const readRepoFile = (dir, rel) => invoke('run_file_read', { dir, rel });

/** Writes it (launch.json validated first; never written when invalid). → { mtime } */
export const writeRepoFile = (dir, rel, content, expectedMtime) => invoke('run_file_write', { dir, rel, content, expectedMtime: expectedMtime ?? null });

/** Copies an env example to `.env` (never overwrites). → the new file's repo-relative path. */
export const copyEnvExample = (dir, from, to) => invoke('run_env_copy', { dir, from, to });
